import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

export const UserCourseLayout = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation()
    const [courses, setCourses] = useState([]);
    const [activeCourse, setactiveCourse] = useState(null);
    const navigate = useNavigate();

    const handleClick = (id) => {
        navigate(`/user/course/subject/${id}`);
    };
    const handleClickAlert = event => {
        event.preventDefault();
        Swal.fire({
            title: "Hata",
            text: "Bu bölümü satın almadınız!",
            icon: "error",
        });
    };

    useEffect(() => {
        const fetchdata = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/user/Content/GetCourse";
                //let url = "https://localhost:7004/api/user/Content/GetCourse";
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            console.log("Course API Response:", res.data['data'])
                            console.log(res.data['data'])

                            setCourses(res.data['data']['courses'])
                            setactiveCourse(res.data['data']['active'])
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchdata();

        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);

    // kullanıcının erişebildiği course id'leri
    const userCourseIds = user?.educationals?.map(x => x.courseId) || [];

    // active kursu en üste taşı
    const sortedCourses = [...courses].sort((a, b) => {
        if (a.id === activeCourse.id) return -1;
        if (b.id === activeCourse.id) return 1;
        return 0;
    });

    return (
        <div>
            {!loading && (
                <div>
                    {sortedCourses && sortedCourses.map((dt) => {
                        const isActiveCourse = dt.id === activeCourse.id;
                        const hasAccess = userCourseIds.includes(dt.id);

                        if (isActiveCourse) {
                            return (
                                <div class="card" style={{ marginTop: "2%", backgroundColor: "Cornsilk" }}>
                                    <div class="card-body">
                                        <p class="card-text">
                                            <div class="row">
                                                <div class="col-md-9 d-flex flex-column justify-content-center text-center">
                                                    <div class="card-body">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    '<p class="card-title text-center"><b>' +
                                                                    dt.courseName +
                                                                    ' #' +
                                                                    t("activeCourse") +
                                                                    "</b></p>",
                                                            }}
                                                        ></div>
                                                        <hr />
                                                        <p class="card-text">
                                                            <b>{dt.courseDesc}</b>
                                                        </p>
                                                        <div className="d-flex justify-content-center">
                                                            <a onClick={() => handleClick(dt.id)} id={dt.id} class="btn btn-primary">
                                                                {t('showsubjects')}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 d-flex justify-content-center align-items-center">
                                                    <img
                                                        style={{ maxHeight: "100px" }}
                                                        src={dt.featuredImage}
                                                        class="img-fluid rounded-start"
                                                        alt="..."
                                                    />
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                        else if (hasAccess) {
                            return (
                                <div class="card" style={{ marginTop: "2%", backgroundColor: "Lavender" }}>
                                    <div class="card-body">
                                        <p class="card-text">
                                            <div class="row">
                                                <div class="col-md-9 d-flex flex-column justify-content-center text-center">
                                                    <div class="card-body">
                                                        <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title">' + dt.courseName + ' # Erişim hakkınız var</h5>' }}></div>
                                                        <hr />
                                                        <p class="card-text">
                                                            <b>{dt.courseDesc}</b>
                                                        </p>
                                                        <a onClick={() => handleClick(dt.id)} id={dt.id} class="btn btn-primary">
                                                            {t('showsubjects')}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 d-flex justify-content-center align-items-center">
                                                    <img
                                                        style={{ maxHeight: "100px" }}
                                                        src={dt.featuredImage}
                                                        class="img-fluid rounded-start"
                                                        alt="..."
                                                    />
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                        else {
                            return (
                                <div class="card" style={{ marginTop: "2%", backgroundColor: "Gainsboro" }}>
                                    <div class="card-body">
                                        <p class="card-text">
                                            <div class="row">
                                                <div class="col-md-9 d-flex flex-column justify-content-center text-center">
                                                    <div class="card-body">
                                                        <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title">' + dt.courseName + '</h5>' }}></div>
                                                        <hr />
                                                        <p class="card-text">
                                                            <b>{dt.courseDesc}</b>
                                                        </p>
                                                        <a onClick={handleClickAlert} id={dt.id} class="btn btn-primary">
                                                            {t('showsubjects')}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 d-flex justify-content-center align-items-center">
                                                    <img
                                                        style={{ maxHeight: "100px" }}
                                                        src={dt.featuredImage}
                                                        class="img-fluid rounded-start"
                                                        alt="..."
                                                    />
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
            )}
        </div>
    );
}

export default UserCourseLayout;